export const getUserLocales = (options = {}) => {
    if (!options?.regionLowerCase)
        options.regionLowerCase = false;
    let locales = [];
    if (Intl && 'DateTimeFormat' in Intl) {
        locales = [Intl.DateTimeFormat().resolvedOptions().locale];
    }
    else if (typeof window === 'object' && window?.navigator?.languages) {
        locales = [...window.navigator.languages];
    }
    return locales.map(locale => {
        if (options.regionLowerCase)
            return locale.toLowerCase();
        return locale;
    });
};
